import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'USD',
    isEnhancedMOV: true,
    includeVAT: false,
    measurement: 'imperial',
    urlBaseName: 'favorites',
};
